import React from 'react';
import { toast } from 'react-toastify';

interface ToastProps {
  type?: 'success' | 'error';
  content?: string | JSX.Element;
}

export const showSimpleToast = ({
  type = 'success',
  content,
}: ToastProps): void => {
  const getToastContent = () => (
    <div className="toast-content">
      {typeof content === 'string'
        ? content.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))
        : content}
    </div>
  );

  toast(getToastContent(), {
    type,
    position: 'bottom-center',
    autoClose: 2000,
    hideProgressBar: true,
    pauseOnHover: true,
  });
};
